<script>

    import { createEventDispatcher } from 'svelte'

    const dispatch = createEventDispatcher()

    export let metadata = {}
    export let page

    function navigate(to) {

        if(to === 'previous' && metadata.previous != null && metadata.previous != undefined) {
            page = metadata.previous
            dispatch('change')
        }

        if(to === 'next' && metadata.next != null && metadata.next != undefined) {
            page = metadata.next
            dispatch('change')
        }
    }

    $: prevDisabled = metadata.previous === null || metadata.previous === undefined
    $: nextDisabled = metadata.next === null || metadata.next === undefined

</script>

<nav class="pagination is-right" role="navigation" aria-label="Paginación">
    <button
        type="button"
        class="pagination-previous"
        disabled={prevDisabled}
        on:click={() => navigate('previous')}
    >
        Anterior
    </button>
    {#if page && !isNaN(page)}
        <ul class="pagination-list">
            <li>
                <span class="pagination-link is-current" aria-current="page">{page}</span>
            </li>
        </ul>
    {/if}
    <button
        type="button"
        class="pagination-next"
        disabled={nextDisabled}
        on:click={() => navigate('next')}
    >
        Siguiente
    </button>
</nav>
